import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VolunteerEnquiryListLayer from "../components/VolunteerEnquiryListLayer";

const VolunteerEnquiryListPage = () => {
  return (
    <>
      <MasterLayout>
        <VolunteerEnquiryListLayer />
      </MasterLayout>
    </>
  );
};
export default VolunteerEnquiryListPage;
